<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/g9gfao/media/FC-9781398405103.jpg?1684514748509" alt="This image is the cover for the book The Life I Won"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Life I Won
      </h1>
      <p class="bookDescription body article font2">
        <p>A gripping tale of strength, resilience and of how life can be devastating yet beautiful at the same time.<br/>She was born to a working-class family in Manchester. Her father was her inspiration. She idolised this charismatic man, and he told her every day that she was special. Emulating her beloved father’s work ethic, Mandy worked on a market stall at thirteen years old, then went off to university at eighteen, always working to help financially. From nothing and nowhere she built a successful career in an unexpected place. She was admired, respected and had made it.<br/>Then her world literally fell apart and life took her on a journey from abundance to rock bottom. There were lessons to be learned on this rocky road and if she wanted to stay alive, it was her duty to learn them.<br/>Facing relentless challenges, losing people she loved and every penny she had, many would have given up. But not this woman, because her dad had told her she was special.<br/>Heart-breaking, enlightening and ultimately uplifting, The Life I Won tells a story of success despite adversity. It will teach you that if you have the right attitude, you can play the game of life and win, no matter how bad it seems.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A. J. King
      </h2>
      
      <p class="authorDescription body article">A. J. King is 57 years old and an artist, coach and author living in Scotland. In 2009 she experienced a series of unfortunate events that would test the strongest person. She survived and learned lessons that would set her up for a dramatic turnaround. Making her story into a work of fiction was the only way she could tell it.<br>This is the first of two books that will share her story of losing everything only to eventually find her holy grail.<br>Her artwork depicts women and their power and her website showcases all of her creative works and her powerful new signature coaching programme ‘The Creative Business Academy.’<br>Find her at www.mandynicholson.co.uk</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2dcbf932